import type { SVGProps } from 'react';

interface TornadoIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

export function TornadoIcon({ className = '', size = 24, ...rest }: TornadoIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      aria-hidden="true"
      className={`drop-shadow-[0_2px_3px_rgba(0,0,0,0.4)] ${className}`}
      {...rest}
    >
      <path
        d="M3.5 5.2C6.6 3.6 12.7 3.1 18.9 5.7"
        stroke="currentColor"
        strokeWidth="2.7"
        strokeLinecap="round"
      />
      <path
        d="M5.3 9.2c2.9-1.4 8.5-1.4 13.1.7"
        stroke="currentColor"
        strokeWidth="2.35"
        strokeLinecap="round"
        opacity="0.94"
      />
      <path
        d="M7.2 13c2.3-1 6.6-.8 9.1.6"
        stroke="currentColor"
        strokeWidth="2.05"
        strokeLinecap="round"
        opacity="0.88"
      />
      <path
        d="M9.2 16.4c1.7-.6 4.3-.4 5.5.4"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        opacity="0.82"
      />
      <path
        d="M11.2 18.9c.7-.3 1.8-.1 2.3.2l-2.7 2.1c-.4.3-.9-.2-.6-.6l1-1.7Z"
        fill="currentColor"
        opacity="0.9"
      />
      <circle cx="19.2" cy="3.4" r="1.2" fill="currentColor" opacity="0.82" />
      <circle cx="4.6" cy="15.6" r="0.9" fill="currentColor" opacity="0.7" />
    </svg>
  );
}
